
import { defineComponent } from "vue";
import SpinnerVue from "./Spinner.vue";
import TimeLine from "./TimeLine.vue";

export default defineComponent({
  name: "Home",
  components: {
    TimeLine,
    SpinnerVue,
  },
});
